// Simple global toast bus usable from any module (including non-React files)

const listeners = new Set();

export function showToast(message, options = {}) {
  if (!message) return;
  const payload = {
    message: String(message),
    severity: options.severity || 'info',
    autoHideDuration:
      typeof options.autoHideDuration === 'number' ? options.autoHideDuration : 4000,
  };

  for (const listener of listeners) {
    try {
      listener(payload);
    } catch {
      // ignore listener errors
    }
  }
}

export function subscribeToToasts(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
